import { gql } from '@apollo/client';

export const FETCH_TERMS = gql`
  fragment contractData on ContractVersion {
    contractType
    displayName
    fileUrl
    id
    scrollRequired
    tag
    contractId
  }

  query Flex_FetchVnmTerms($stateId: Int!, $tags: [ContractTag!]!, $utilityAccountId: Int!) {
    utilityAccount(id: $utilityAccountId) {
      id
      subscriberContractRequirement {
        dependencies {
          __typename
          status
          ... on ContractSubscriberRequirement {
            contract {
              contractId: id
              contractType
              displayName
              tag
              currentVersion {
                id
                fileUrl
                scrollRequired
                signatureType
              }
            }
          }
        }
      }
    }
    generalContractVersions(contractType: [vnm, terms, privacy]) {
      ...contractData
    }
    lmiForm: currentContractVersion(stateId: $stateId, contractType: lmi) {
      ...contractData
    }
    taggedContractVersions(stateId: $stateId, tag: $tags) {
      ...contractData
    }
  }
`;
